export default __webpack_public_path__ + "static/media/ic_notification_compose.d9da6e08.svg";